/* Carrito de Bolt hacia Odoo: SKU del contrato, cálculo con la tabla de precios de Odoo y validación de datos de entrega.
   Sin acceso al navegador: se puede probar en node (work/test-carrito.cjs). Contrato: docs/CONTRATO.md */
(function(root){
'use strict';
const round=n=>Math.round(n*100)/100;
/* id del catálogo web -> SKU del contrato (work/shopify-odoo-mapeo/preparacion-conexion/variantes-a-conectar.csv) */
const SKU={'whey-van':'BOLT-WHEY-VAN','whey-cho':'BOLT-WHEY-CHO','fit-van':'BOLT-FIT-VAN','fit-cho':'BOLT-FIT-CHO','gainer-van':'BOLT-GAINER-VAN','gainer-cho':'BOLT-GAINER-CHO','crea-30':'BOLT-CREA-30','crea-60':'BOLT-CREA-60','pre-san':'BOLT-PRE-SAN','pre-man':'BOLT-PRE-MAN','colageno':'BOLT-COLAGENO','amino':'BOLT-AMINO'};
/* familia del combo (prefijo del id del producto principal) -> SKU del combo */
const COMBO={whey:'COMBO-MASA',fit:'COMBO-DEF',gainer:'COMBO-PESO'};
const MAX_LINEA=9;
const productId=l=>l.productId||l.mainId||(l.flavor==='Vainilla'?'whey-van':'whey-cho');
const familia=id=>String(id).split('-')[0];

/* Estado de la tabla de precios de Odoo (null = usar precios locales solo para mostrar) */
let tabla=null;

function normalizarPrecios(json){
  if(!json||typeof json!=='object'||!Array.isArray(json.productos))return null;
  const t={version:String(json.version||''),moneda:json.moneda||'GTQ',unit:{},regular:{},combo:{},sabores:{}};
  for(const p of json.productos){
    if(!p||typeof p.sku!=='string')continue;
    if(p.tipo==='combo'){const pr=Number(p.precio);if(pr>0){t.combo[p.sku]=pr;t.sabores[p.sku]=Array.isArray(p.sabores)?p.sabores.slice():[];}}
    else if(p.precios&&typeof p.precios==='object'){
      const u={};for(const n of [1,2,3,4]){const v=Number(p.precios[String(n)]);if(!(v>0))return null;u[n]=v;}
      t.unit[p.sku]=u;const r=Number(p.regular);t.regular[p.sku]=r>0?r:u[1];
    }
  }
  return Object.keys(t.unit).length?t:null;
}
function setTabla(t){tabla=t||null;}
function getTabla(){return tabla;}

/* Motivo por el que el carrito no se puede pagar con tarjeta (null = se puede) */
function elegibilidad(lines){
  if(!lines||!lines.length)return{ok:false,motivo:'vacio'};
  if(lines.some(l=>l.kind==='mega'))return{ok:false,motivo:'anual'};
  if(lines.some(l=>l.mode==='subscription'))return{ok:false,motivo:'suscripcion'};
  const r=lineasContrato(lines);
  if(!r.ok)return{ok:false,motivo:r.motivo};
  if(r.excede)return{ok:false,motivo:'cantidad',max:MAX_LINEA};
  return{ok:true,motivo:null};
}

/* Líneas del contrato: [{sku,cantidad,sabor?}] con SKU repetidos sumados */
function lineasContrato(lines){
  const acc=new Map();
  for(const l of lines){
    if(l.kind==='mega')return{ok:false,motivo:'anual'};
    if(l.mode==='subscription')return{ok:false,motivo:'suscripcion'};
    const qty=Number(l.qty);if(!Number.isInteger(qty)||qty<1)return{ok:false,motivo:'cantidad'};
    let sku,sabor,k;
    if(l.kind==='combo'){
      const main=productId(l);sku=COMBO[familia(main)];sabor=SKU[main];
      if(!sku||!sabor)return{ok:false,motivo:'sku'};
      k=sku+'|'+sabor;
    }else{
      sku=SKU[productId(l)];if(!sku)return{ok:false,motivo:'sku'};k=sku;
    }
    const cur=acc.get(k);if(cur)cur.cantidad+=qty;else acc.set(k,sabor?{sku,cantidad:qty,sabor}:{sku,cantidad:qty});
  }
  const lineas=[...acc.values()];
  return{ok:true,lineas,excede:lineas.some(x=>x.cantidad>MAX_LINEA)};
}

/* Total con la tabla de Odoo: escalón por unidades de productos (los combos no suman escalón y tienen precio fijo). null si falta algún SKU. */
function cotizarTabla(lineas,t){
  if(!t)return null;
  const unidades=lineas.filter(x=>!x.sabor&&!COMBO_SKUS.has(x.sku)).reduce((a,x)=>a+x.cantidad,0);
  const esc=Math.min(Math.max(unidades,1),4);
  let total=0,regular=0;
  for(const x of lineas){
    if(COMBO_SKUS.has(x.sku)){const p=t.combo[x.sku];if(!(p>0))return null;total+=p*x.cantidad;}
    else{const u=t.unit[x.sku];if(!u)return null;total+=u[esc]*x.cantidad;regular+=(t.regular[x.sku]||u[1])*x.cantidad;}
  }
  return{total:round(total),unidades,escalon:esc,regularProductos:round(regular)};
}
const COMBO_SKUS=new Set(Object.values(COMBO));

/* Sobre la cotización local (commerce.js) pone el total de Odoo cuando hay tabla y la compra es única */
function aplicar(q,lines){
  if(!tabla||!lines.length)return q;
  const r=lineasContrato(lines);/* con más de 9 por línea igual se muestra el precio; solo el pago con tarjeta se bloquea */
  if(!r.ok)return q;
  const c=cotizarTabla(r.lineas,tabla);if(!c)return q;
  return Object.assign({},q,{total:c.total,grand:c.total,payable:c.total,shipping:0,ahorro:round(Math.max(0,q.normal-c.total)),tier:c.unidades>=4?.3:c.unidades===3?.25:c.unidades===2?.2:0,odoo:true});
}

/* Aplica los precios de Odoo al catálogo local para pintar precios en tarjetas y selectores */
function aplicarCatalogo(C,t){
  if(!C||!t)return false;
  const inv={};for(const [id,sku] of Object.entries(SKU))inv[sku]=id;
  for(const p of C.PRODUCTOS){const sku=SKU[p.id],u=t.unit[sku];if(!u)continue;p.normal=t.regular[sku]||p.normal;p.unidad=u[1];p.total2=round(u[2]*2);p.total3=round(u[3]*3);}
  for(const c of C.COMBOS){const sku=COMBO[c.id==='musculo'?'whey':c.id==='definicion'?'fit':'gainer'];if(t.combo[sku]>0)c.oferta=t.combo[sku];}
  return true;
}

/* Datos de entrega */
const DEPARTAMENTOS=['Alta Verapaz','Baja Verapaz','Chimaltenango','Chiquimula','El Progreso','Escuintla','Guatemala','Huehuetenango','Izabal','Jalapa','Jutiapa','Petén','Quetzaltenango','Quiché','Retalhuleu','Sacatepéquez','San Marcos','Santa Rosa','Sololá','Suchitepéquez','Totonicapán','Zacapa'];
function telefono8(v){let d=String(v||'').replace(/\D/g,'');if(d.length===11&&d.startsWith('502'))d=d.slice(3);return d;}
function normalizarNit(v){const s=String(v||'').replace(/[\s.]/g,'').toUpperCase();if(!s||s==='CF'||s==='C/F')return'CF';return s;}
function validarCliente(c){
  const e={},t=s=>String(s==null?'':s).trim();
  const nombre=t(c.nombre).replace(/\s+/g,' '),email=t(c.email).toLowerCase(),tel=telefono8(c.telefono),nit=normalizarNit(c.nit),depto=t(c.departamento),muni=t(c.municipio).replace(/\s+/g,' '),dir=t(c.direccion).replace(/\s+/g,' '),ref=t(c.referencias);
  if(nombre.length<5||!nombre.includes(' '))e.nombre='Escribí tu nombre y apellido.';
  if(!/^\d{8}$/.test(tel))e.telefono='El teléfono debe tener 8 dígitos.';
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email))e.email='Escribí un correo válido, ahí te llega el recibo.';
  if(nit!=='CF'&&!/^\d{1,12}-?[\dK]$/.test(nit))e.nit='El NIT no parece válido. Dejalo vacío para consumidor final (CF).';
  if(!DEPARTAMENTOS.includes(depto))e.departamento='Elegí tu departamento.';
  if(muni.length<2)e.municipio='Escribí tu municipio.';
  if(dir.length<8)e.direccion='Escribí tu dirección completa: calle, zona, casa o edificio.';
  if(ref.length>300)e.referencias='Máximo 300 caracteres.';
  return{ok:!Object.keys(e).length,errores:e,cliente:{nombre,telefono:tel,email,nit,departamento:depto,municipio:muni,direccion:dir,referencias:ref}};
}

/* carrito_id: uuid v4 (idempotencia) */
function uuid(cripto){
  const c=cripto||(root.crypto);
  if(c&&typeof c.randomUUID==='function')return c.randomUUID();
  const b=new Uint8Array(16);if(c&&c.getRandomValues)c.getRandomValues(b);else for(let i=0;i<16;i++)b[i]=Math.floor(Math.random()*256);
  b[6]=(b[6]&15)|64;b[8]=(b[8]&63)|128;const h=[...b].map(x=>x.toString(16).padStart(2,'0'));
  return h.slice(0,4).join('')+'-'+h.slice(4,6).join('')+'-'+h.slice(6,8).join('')+'-'+h.slice(8,10).join('')+'-'+h.slice(10).join('');
}
function firma(lineas){return JSON.stringify(lineas.map(x=>[x.sku,x.sabor||'',x.cantidad]).sort());}
/* Devuelve el carrito_id vigente: se reusa mientras el contenido no cambie */
function carritoId(store,lineas,cripto){
  const f=firma(lineas);
  try{const g=JSON.parse(store.getItem('bolt-carrito-id')||'null');if(g&&g.firma===f&&typeof g.id==='string')return g.id;}catch{}
  const id=uuid(cripto);try{store.setItem('bolt-carrito-id',JSON.stringify({id,firma:f}));}catch{}
  return id;
}

/* Cuerpo del POST /bolt/checkout */
/* meta para la Conversions API: {fbp,fbc,url}; objeto vacío si no hay pixel. url sin query ni hash. */
function armarMeta(o){
  if(!o||!o.pixel)return{};
  const ck=n=>{const m=String(o.cookies||'').match(new RegExp('(?:^|;\\s*)'+n+'=([^;]*)'));return m?decodeURIComponent(m[1]):'';};
  let fbc=ck('_fbc');if(!fbc&&o.fbclid)fbc='fb.1.'+(o.fbclidTs||Date.now())+'.'+o.fbclid;
  let url='';try{const u=new URL(o.href);url=u.origin+u.pathname;}catch{}
  const m={};const fbp=ck('_fbp');if(fbp)m.fbp=fbp;if(fbc)m.fbc=fbc;if(url)m.url=url;return m;
}
function armarPedido(o){return{carrito_id:o.carritoId,lineas:o.lineas,cliente:o.cliente,total_visto:round(o.totalVisto),sitio:'bolt-web-v1',hp:o.hp||'',meta:o.meta||{}};}

/* URL base configurada en el tema: solo https (o http en localhost para pruebas). Devuelve '' si no sirve. */
function baseUrl(v){
  const s=String(v||'').trim().replace(/\/+$/,'');if(!s)return'';
  try{const u=new URL(s);if(u.protocol==='https:'||(u.protocol==='http:'&&/^(localhost|127\.0\.0\.1|\[::1\])$/.test(u.hostname)))return u.origin+u.pathname.replace(/\/+$/,'');}catch{}
  return'';
}
/* checkout_url válido: https en recurrente.com o en el mismo host de la base (pruebas en staging) */
function urlPagoValida(url,base){
  try{const u=new URL(url);if(u.protocol!=='https:')return false;const h=u.hostname;if(h==='recurrente.com'||h.endsWith('.recurrente.com'))return true;if(base){try{return new URL(base).hostname===h;}catch{}}}catch{}
  return false;
}

const api={SKU,COMBO,MAX_LINEA,DEPARTAMENTOS,normalizarPrecios,setTabla,getTabla,elegibilidad,lineasContrato,cotizarTabla,aplicar,aplicarCatalogo,validarCliente,telefono8,normalizarNit,uuid,carritoId,firma,armarPedido,armarMeta,baseUrl,urlPagoValida,productId};
if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.BoltOdoo=api;
})(typeof window!=='undefined'?window:globalThis);
